import React, { useEffect, lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import '../../styles/styles.css';
import '../../styles/custom-fixes.css';
import { useThemeMode } from '../../ThemeContext';
import SiteHeader from '../../components/SiteHeader';
import useSeoMeta from '../SeoPages/useSeoMeta';
import { getPublicSeoPage } from '../../seo/publicPages';
import DemoTrail from './DemoTrail';
import ComplianceInfo from './ComplianceInfo';
import CompleteWHSCompliance from './CompleteWHSCompliance';

const HowItWorks = lazy(() => import('./HowItWorks'));
const MobileApps = lazy(() => import('./MobileApps'));
const PlanDetails = lazy(() => import('./PlanDetails'));
const ComplianceTeams = lazy(() => import('./ComplianceTeams'));
const FAQ = lazy(() => import('./FAQ'));
const Footer = lazy(() => import('./Footer'));

function Home() {
  const { mode } = useThemeMode();
  const { hash } = useLocation();
  const homeSeo = getPublicSeoPage('/');
  useSeoMeta(homeSeo);

  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  useEffect(() => {
    const id = hash ? hash.replace('#', '') : '';
    if (!id) return undefined;

    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    if (scrollToSection()) return undefined;
    const retry = window.setTimeout(scrollToSection, 150);
    return () => window.clearTimeout(retry);
  }, [hash]);

  return (
    <div style={{ backgroundColor: mode === 'dark' ? '#111' : '#fff', minHeight: '100vh' }}>
      <SiteHeader />
      <DemoTrail />
      <ComplianceInfo />
      <CompleteWHSCompliance />
      <Suspense fallback={null}>
        <HowItWorks />
        <MobileApps />
        <PlanDetails />
        <ComplianceTeams />
        <FAQ />
        <Footer />
      </Suspense>
    </div>
  );
}

export default Home;
